import { FormFieldConfig } from "interfaces/forms";

type fields =
  | "descricao"
  | "distancia"
  | "unidade"
  | "qtdLimite"
  | "incluiCamiseta";

const formFieldDistancia: FormFieldConfig<fields> = {
  descricao: {
    name: "descricao",
    label: "Descricão",
    type: "text",
    errorMsg: "Campo obrigatório.",
  },
  distancia: {
    name: "distancia",
    label: "Distância",
    type: "number",
    errorMsg: "Campo obrigatório.",
  },
  unidade: {
    name: "unidade",
    label: "Unidade",
    type: "text",
    errorMsg: "Campo obrigatório.",
  },
  qtdLimite: {
    name: "qtdLimite",
    label: "Qtd. Limite",
    type: "number",
    errorMsg: "Campo obrigatório.",
    invalidMsg: "Qtd. Limite deve ser maior que zero.",
  },
  incluiCamiseta: {
    name: "incluiCamiseta",
    label: "Exibir camiseta nesta distância",
    type: "checkbox",
  },
};

export default formFieldDistancia;
